export const fonts = {
  'Alegreya Sans SC': require('./definitions/Alegreya Sans SC.json'),
  'Lush Script': require('./definitions/Allura.json'),
  'Amatic SC': require('./definitions/Amatic SC.json'),
  'Architects Daughter': require('./definitions/Architects Daughter.json'),
  'Averia Serif Libre': require('./definitions/Averia Serif Libre.json'),
  Boogaloo: require('./definitions/Boogaloo.json'),
  Abril: require('./definitions/Cambo.json'),
  Capriola: require('./definitions/Capriola.json'),
  'Clicker Script': require('./definitions/Clicker Script.json'),
  Comfortaa: require('./definitions/Comfortaa.json'),
  'Coming Soon': require('./definitions/Coming Soon.json'),
  'Dancing Script': require('./definitions/Dancing Script.json'),
  Domine: require('./definitions/Domine.json'),
  'Emilys Candy': require('./definitions/Emilys Candy.json'),
  Komu: require('./definitions/Fjalla One.json'),
  'AW Conqueror Carved': require('./definitions/Fredericka the Great.json'),
  'Great Vibes': require('./definitions/Great Vibes.json'),
  Gudea: require('./definitions/Gudea.json'),
  Handlee: require('./definitions/Handlee.json'),
  'Happy Monkey': require('./definitions/Happy Monkey.json'),
  'Indie Flower': require('./definitions/Indie Flower.json'),
  'Josefin Sans': require('./definitions/Josefin Sans.json'),
  Karma: require('./definitions/Karma.json'),
  Kranky: require('./definitions/Kranky.json'),
  Meddon: require('./definitions/Meddon.json'),
  Molengo: require('./definitions/Molengo.json'),
  'Mukta Vaani': require('./definitions/Mukta Vaani.json'),
  Muli: require('./definitions/Muli.json'),
  Nicgonne: require('./definitions/Niconne.json'),
  'Nixie One': require('./definitions/Nixie One.json'),
  Pacifico: require('./definitions/Pacifico.json'),
  Parisienne: require('./definitions/Parisienne.json'),
  'Penna Connected': require('./definitions/Pinyon Script.json'),
  Pompiere: require('./definitions/Pompiere.json'),
  Poppins: require('./definitions/Poppins.json'),
  Questrial: require('./definitions/Questrial.json'),
  'Effra Regular': require('./definitions/Raleway.json'),
  'Museo Slab': require('./definitions/Roboto Slab.json'),
  'Proxima Nova': require('./definitions/Roboto.json'),
  Rubik: require('./definitions/Rubik.json'),
  Rye: require('./definitions/Rye.json'),
  Sacramento: require('./definitions/Sacramento.json'),
  Sanchez: require('./definitions/Sanchez.json'),
  Satisfy: require('./definitions/Satisfy.json'),
  'Scope One': require('./definitions/Scope One.json'),
  'Shadows Into Light Two': require('./definitions/Shadows Into Light Two.json'),
  'Sax Mono': require('./definitions/Space Mono.json'),
  Stalemate: require('./definitions/Stalemate.json'),
  'Ambroise Firmin': require('./definitions/Stint Ultra Condensed.json'),
  Taviraj: require('./definitions/Taviraj.json')
};
